import React from "react";
import {FormattedMessage} from "react-intl";
import RadioButtonGroupPcbColor from "../../RadioButtonGroup/RadioButtonPcbColor/RadioButtonGroup3";
import {Link} from "react-router-dom";

let color = [
    {
        id: 0,
        checked: true,
        name: "pcbColor",
        text: <FormattedMessage id="app.pcb-quotation.pcb-color-green"
                                defaultMessage="Green" description=""/>,
        disabled: false
    },
    {
        id: 1,
        checked: false,
        name: "pcbColor",
        text: <FormattedMessage id="app.pcb-quotation.pcb-color-red"
                                defaultMessage="Red" description=""/>,
        disabled: false
    },
    {
        id: 2,
        checked: false,
        name: "pcbColor",
        text: <FormattedMessage id="app.pcb-quotation.pcb-color-yellow"
                                defaultMessage="Yellow" description=""/>,
        disabled: false
    },
    {
        id: 3,
        checked: false,
        name: "pcbColor",
        text: <FormattedMessage id="app.pcb-quotation.pcb-color-blue"
                                defaultMessage="Blue" description=""/>,
        disabled: false
    },
    {
        id: 4,
        checked: false,
        name: "pcbColor",
        text: <FormattedMessage id="app.pcb-quotation.pcb-color-white"
                                defaultMessage="White" description=""/>,
        disabled: false
    },
    {
        id: 5,
        checked: false,
        name: "pcbColor",
        text: <FormattedMessage id="app.pcb-quotation.pcb-color-black"
                                defaultMessage="Black" description=""/>,
        disabled: false
    },
];

let pcbColorLayer6 = [
    {
        id: 0,
        checked: true,
        name: "pcbColor",
        text: <FormattedMessage id="app.pcb-quotation.pcb-color-green"
                                defaultMessage="Green" description=""/>,
        disabled: false
    },
    {
        id: 1,
        checked: false,
        name: "pcbColor",
        text: <FormattedMessage id="app.pcb-quotation.pcb-color-red"
                                defaultMessage="Red" description=""/>,
        disabled: false
    },
    {
        id: 2,
        checked: false,
        name: "pcbColor",
        text: <FormattedMessage id="app.pcb-quotation.pcb-color-yellow"
                                defaultMessage="Yellow" description=""/>,
        disabled: false
    },
    {
        id: 3,
        checked: false,
        name: "pcbColor",
        text: <FormattedMessage id="app.pcb-quotation.pcb-color-blue"
                                defaultMessage="Blue" description=""/>,
        disabled: false
    },
    {
        id: 4,
        checked: false,
        name: "pcbColor",
        text: <FormattedMessage id="app.pcb-quotation.pcb-color-white"
                                defaultMessage="White" description=""/>,
        disabled: false
    },
    {
        id: 5,
        checked: false,
        name: "pcbColor",
        text: <FormattedMessage id="app.pcb-quotation.pcb-color-black"
                                defaultMessage="Black" description=""/>,
        disabled: false
    },
];

const PCBColor = (props) => {
    let thickness = props.pcbParams.thickness;
    let layer = props.pcbParams.layer;
    let pcbColor = color.map((item) => {
        item.checked = (item.id === props.selectedId);
        if (thickness === 0.4 && layer === 2) {
            item.disabled = item.id === 1 || item.id === 2;
        } else {
            item.disabled = false;
        }

        return item;
    });

    return (
        <div className="row">
            <div className="col-md-12 no-padding">
                <div className="pcb-details-div">
                    <div className="col-md-3 text-right content-item-heading">
                        <FormattedMessage id="app.pcb-quotation.pcb-color"
                                          defaultMessage="PCB Color"
                                          description=""
                        />
                        &nbsp; &nbsp;
                        <Link id="pcbClr-qLink"
                            to={{pathname:"https://kitcutlabo.com/resist-color/"}} target="_self"
                            className="glyphicon glyphicon-question-sign question-link"></Link>
                    </div>
                    <div className="btn-group col-md-9 pcb-details-div-items">

                        {props.pcbParams.layer !== 6 ?
                            <RadioButtonGroupPcbColor data={pcbColor} getParams={props.setPCBParams}/>
                            :''
                        }

                        {props.pcbParams.layer === 6 ?

                            <RadioButtonGroupPcbColor data={pcbColorLayer6} getParams={props.setPCBParams}/>
                            :''
                        }

                        <p className="pcb-details-div-clr-caption ">
                            {/*&#x1360; */}
                            {/*<FormattedMessage id="app.pcb-quotation.pcb-color-caption"*/}
                                              {/*defaultMessage="シルクカラーはレジストカラーにより指定されます。製造仕様参照"*/}
                                              {/*description=""/><span className="spaceSpan">  </span>*/}
                            {/*<link id="pcbstnclSide-qLink" to="" className="glyphicon glyphicon-question-sign question-link"></link>*/}

                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default PCBColor;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/PCBColor.js